// Per-state, per-pillar beneficiary split — computed deterministically from
// each state's active pillars + global pillar weights (FY 24-25 mix).
// Returns an array of { state, employability, entrepreneurship, environment, total }.

import { STATE_REACH } from "./states";

const GLOBAL_WEIGHTS = {
  employability:    7200,
  entrepreneurship: 18300,
  environment:      520,
};

export function pillarSplitForState(s) {
  // Determine which pillars are active for this state
  const active = s.pillars; // array of pillar ids
  // Weights restricted to active pillars
  const totalWeight = active.reduce((sum, pid) => sum + GLOBAL_WEIGHTS[pid], 0);
  const out = { employability: 0, entrepreneurship: 0, environment: 0 };
  active.forEach((pid) => {
    out[pid] = Math.round(s.beneficiaries * (GLOBAL_WEIGHTS[pid] / totalWeight));
  });
  return out;
}

export const STATE_PILLAR_MATRIX = STATE_REACH.map((s) => {
  const split = pillarSplitForState(s);
  return {
    state: s.state,
    total: s.beneficiaries,
    ...split,
  };
});
